import { Fragment, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import RatingStars from '../helpers/RatingStars'
import moment from 'moment'
import get from 'lodash/get'
import OperatorReply from './OperatorReply'

function renderDetailedRating(detailedRating, kind) {
  return (
    <Fragment>
      {kind === 20 ? (
        <Fragment>
          <div className='rating-wrap'>
            <FormattedMessage id='resort' defaultMessage='Resort' />
            <span className='rating-val'>
              <RatingStars rating={detailedRating.rateResort} />
            </span>
          </div>
          <div className='rating-wrap'>
            <FormattedMessage id='dive_center' defaultMessage='Dive center' />
            <span className='rating-val'>
              <RatingStars rating={detailedRating.rateDiveCenter} />
            </span>
          </div>
          <div className='rating-wrap'>
            <FormattedMessage id='service' defaultMessage='Service' />
            <span className='rating-val'>
              <RatingStars rating={detailedRating.rateService} />
            </span>
          </div>
          <div className='rating-wrap'>
            <FormattedMessage id='rooms' defaultMessage='Rooms' />
            <span className='rating-val'>
              <RatingStars rating={detailedRating.rateRooms} />
            </span>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          <div className='rating-wrap'>
            <FormattedMessage id='vessel' defaultMessage='Vessel' />
            <span className='rating-val'>
              <RatingStars rating={detailedRating.rateVessel} />
            </span>
          </div>
          <div className='rating-wrap'>
            <FormattedMessage
              id='dive_infrastructure'
              defaultMessage='Dive infrastructure'
            />
            <span className='rating-val'>
              <RatingStars rating={detailedRating.rateDiveInfrastructure} />
            </span>
          </div>
          <div className='rating-wrap'>
            <FormattedMessage id='service' defaultMessage='Service' />
            <span className='rating-val'>
              <RatingStars rating={detailedRating.rateService} />
            </span>
          </div>
          <div className='rating-wrap'>
            <FormattedMessage id='cabins' defaultMessage='Cabins' />
            <span className='rating-val'>
              <RatingStars rating={detailedRating.rateCabins} />
            </span>
          </div>
        </Fragment>
      )}
      <div className='rating-wrap'>
        <FormattedMessage
          id='rental_equipment'
          defaultMessage='Rental equipment'
        />
        <span className='rating-val'>
          <RatingStars rating={detailedRating.rateRentalEquipment} />
        </span>
      </div>
      <div className='rating-wrap'>
        <FormattedMessage id='safety' defaultMessage='Safety' />
        <span className='rating-val'>
          <RatingStars rating={detailedRating.rateSafety} />
        </span>
      </div>
      <div className='rating-wrap'>
        <FormattedMessage id='food' defaultMessage='Food' />
        <span className='rating-val'>
          <RatingStars rating={detailedRating.rateFood} />
        </span>
      </div>
      <div className='rating-wrap'>
        <FormattedMessage id='staff' defaultMessage='Staff' />
        <span className='rating-val'>
          <RatingStars rating={detailedRating.rateStaff} />
        </span>
      </div>
      <div className='rating-wrap'>
        <FormattedMessage id='value' defaultMessage='Value' />
        <span className='rating-val'>
          <RatingStars rating={detailedRating.rateValue} />
        </span>
      </div>
    </Fragment>
  )
}

let page = 1

export default function DiverRating({
  averageVotes,
  reviews,
  next,
  getMore,
  kind,
}) {
  const [isOpen, triggerOpen] = useState({})
  if(!reviews.length) {
    return (
      <div className='detailed-rating no-border'>
        <p>
          <FormattedMessage
            id='not_enought_reviews'
            defaultMessage='We don`t have enough ratings for this dive operator to display them yet'
          />
        </p>
      </div>
    )
  }

  return (
    <div className='tabs-container fade-onload'>
      <div
        className='detailed-rating'
      >
        {renderDetailedRating(averageVotes, kind)}
      </div>
      <div className='reviews-block'>
        <div className='review-wrap full-width'>
          {reviews.map((review) => {
            const lastName = get(review, 'account.lastName')
            return (
              <div
                key={review.id}
                className='review'
              >
                <div className='img-wrap'>
                  <img src={review.account.avatar.DOReviewAvatar} />
                </div>
                <div className='text-wrap'>
                  <div className='star-wrapper'>
                    <star-rating
                      rating-value='review.rate'
                      class='rating-elem'
                    />
                    <span className='date'>
                      <FormattedMessage
                        id='reviews_on_date'
                        values={{
                          date: moment(
                            review.tripStartDate
                              ? review.tripStartDate
                              : review.created
                          ).format('MMMM DD, YYYY'),
                        }}
                        defaultMessage='Reviewed on {date}'
                      />
                    </span>
                  </div>
                  <p
                    ng-init='cutLength=150'
                    ng-bind='review.comment | cut:true:cutLength'
                    className='review-text'
                  >
                    {isOpen[review.id]
                      ? review.comment
                      : review.comment.substr(0, 150)}
                  </p>
                  <p className='reviewer-name'>
                    <span>
                      {review.account.firstName}
                      {lastName ? ` ${lastName.substr(0, 1)}.` : ''}
                    </span>
                    {!isOpen[review.id] ? (
                      <span
                        onClick={() =>
                          triggerOpen({ ...isOpen, [review.id]: true })
                        }
                        className='more'
                      >
                        <FormattedMessage
                          id='show_details'
                          defaultMessage='Show details'
                        />
                      </span>
                    ) : (
                      ''
                    )}
                  </p>
                  {isOpen[review.id] && (
                    <div
                      ng-show='showReview[$index] === true'
                      className='detailed-rating fade-onload'
                    >
                      <div className='main-rating-wrap'>
                        {renderDetailedRating(review, kind)}
                      </div>
                      <div className='expand-btn'>
                        <span
                          onClick={() =>
                            triggerOpen({ ...isOpen, [review.id]: false })
                          }
                          className='more active'
                        >
                          <FormattedMessage
                            id='hide_details'
                            defaultMessage='Hide details'
                          />
                        </span>
                      </div>
                    </div>
                  )}
                  {review.reply && (
                    <OperatorReply
                      operatorImg={window.shop.operatorImg}
                      operatorTitle={window.shop.title}
                      operatorReply={review.reply}
                    />
                  )}
                </div>
              </div>
            )
          })}
          {next ? (
            <button
              ng-class="{'loading': operator.reviewsLoading}"
              ng-disabled='operator.reviewsLoading'
              onClick={() => getMore((page += 1))}
              className='btn-outline'
            >
              <FormattedMessage
                id='see_more_reviews'
                defaultMessage='See more reviews'
              />
            </button>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  )
}
